import type CrudAction from '@/features/crud/CrudAction';

import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '@/features/crud/CrudActionType';

const LandingsPage = async () => import('@/pages/LandingsPage.vue');
const LandingsMassEditModal = async () =>
  import('@/features/landings/landings-mass-edit-modal/LandingsMassEditModal.vue');

export default function getLandingsRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'landings',
      children: [
        {
          name: 'edit-many-landings',
          component: LandingsMassEditModal,
          path: String.raw`edit/mass/:ids(\d+)+`,
          props: (route) => ({
            landingIds: route.params.ids,
          }),
        },
      ],
      component: LandingsPage,
      meta: {
        title: 'Landers',
        useIn: ['navigation-tabs'],
      },
      path: '/landings',
      props: () => ({
        crudAction: null,
      }),
    },
    {
      name: 'create-landing',
      component: LandingsPage,
      path: '/landings/create',
      props: (): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          type: CrudActionType.CREATE,
        },
      }),
    },
    {
      name: 'edit-landing',
      component: LandingsPage,
      path: '/landings/edit/:id',
      props: (
        route,
      ): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          id: route.params.id as string,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      name: 'clone-landing',
      component: LandingsPage,
      path: '/landings/clone/:id',
      props: (
        route,
      ): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          id: route.params.id as string,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
